package com.evoapps.evoshift.ui.kiosk

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.interaction.MutableInteractionSource
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.theme.pressScale
import com.evoapps.evoshift.widgets.LocalActionFeedback
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import androidx.compose.material3.Button
import evoshift.composeapp.generated.resources.kiosk_photo_skip
import evoshift.composeapp.generated.resources.kiosk_photo_take
import evoshift.composeapp.generated.resources.kiosk_photo_explained
import evoshift.composeapp.generated.resources.kiosk_photo_title
import evoshift.composeapp.generated.resources.kiosk_unplanned_extra
import evoshift.composeapp.generated.resources.kiosk_unplanned_cover
import evoshift.composeapp.generated.resources.kiosk_break_end
import evoshift.composeapp.generated.resources.kiosk_break_start
import evoshift.composeapp.generated.resources.kiosk_confirm_break_end
import evoshift.composeapp.generated.resources.kiosk_confirm_break_start
import evoshift.composeapp.generated.resources.kiosk_state_on_break
import androidx.compose.material3.OutlinedButton
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawingPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.Backspace
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.CloudOff
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material.icons.filled.PersonSearch
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.ClockAction
import com.evoapps.evoshift.domain.model.KioskPerson
import com.evoapps.evoshift.domain.model.KioskTile
import com.evoapps.evoshift.domain.model.KioskTileState
import com.evoapps.evoshift.kiosk.KioskLockHint
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.viewmodels.KioskQrState
import com.evoapps.evoshift.viewmodels.KioskStep
import com.evoapps.evoshift.viewmodels.KioskUiState
import com.evoapps.evoshift.viewmodels.KioskViewModel
import com.evoapps.evoshift.viewmodels.KioskTipsViewModel
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.GoldButton
import com.evoapps.evoshift.widgets.UserAvatar
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.back
import evoshift.composeapp.generated.resources.close
import evoshift.composeapp.generated.resources.kiosk_back_soon
import evoshift.composeapp.generated.resources.kiosk_clock_auto
import evoshift.composeapp.generated.resources.kiosk_clock_in
import evoshift.composeapp.generated.resources.kiosk_clock_out
import evoshift.composeapp.generated.resources.kiosk_confirm_in
import evoshift.composeapp.generated.resources.kiosk_confirm_out
import evoshift.composeapp.generated.resources.kiosk_confirm_queued
import evoshift.composeapp.generated.resources.kiosk_delete_digit
import evoshift.composeapp.generated.resources.kiosk_enter_pin
import evoshift.composeapp.generated.resources.kiosk_exit
import evoshift.composeapp.generated.resources.kiosk_exit_confirm
import evoshift.composeapp.generated.resources.kiosk_exit_text
import evoshift.composeapp.generated.resources.kiosk_guided_access_hint
import evoshift.composeapp.generated.resources.kiosk_no_matches
import evoshift.composeapp.generated.resources.kiosk_no_one_today
import evoshift.composeapp.generated.resources.kiosk_offline_waiting
import evoshift.composeapp.generated.resources.kiosk_qr_description
import evoshift.composeapp.generated.resources.kiosk_qr_hint
import evoshift.composeapp.generated.resources.kiosk_qr_offline
import evoshift.composeapp.generated.resources.kiosk_search_hint
import evoshift.composeapp.generated.resources.kiosk_someone_else
import evoshift.composeapp.generated.resources.kiosk_state_done
import evoshift.composeapp.generated.resources.kiosk_state_later
import evoshift.composeapp.generated.resources.kiosk_state_ready
import evoshift.composeapp.generated.resources.kiosk_state_working
import evoshift.composeapp.generated.resources.kiosk_who_title
import io.github.alexzhirkevich.qrose.options.QrErrorCorrectionLevel
import io.github.alexzhirkevich.qrose.options.QrOptions
import io.github.alexzhirkevich.qrose.rememberQrCodePainter
import org.jetbrains.compose.resources.stringResource

/** Test tags of the kiosk screen (robots find the PIN pad's keys by them). */
object KioskTags {
    const val GRID = "kiosk_grid"
    const val PIN_PAD = "kiosk_pin_pad"
    const val PIN_DOTS = "kiosk_pin_dots"
    const val EXIT = "kiosk_exit"
    /** SH-111: the rotating QR panel (the code itself, or the offline note). */
    const val QR = "kiosk_qr"
    const val QR_CODE = "kiosk_qr_code"
    /** SH-116: the PIN pad's second button (start a break, or clock out during one). */
    const val OTHER_ACTION = "kiosk_other_action"
    fun key(digit: Char) = "kiosk_key_$digit"
}

/**
 * SH-107: the clock-in tablet's whole screen. Navy and gold like the app, large touch targets,
 * one column of controls in portrait and side by side in landscape. Nothing else of the app is
 * reachable from here: leaving needs a manager's PIN.
 */
@Composable
fun KioskScreen(
    viewModel: KioskViewModel,
    /** SH-124: the day's tips (a manager's PIN); null: no "Tips" button. */
    tips: KioskTipsViewModel? = null
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val tipsState = tips?.uiState?.collectAsState()?.value
    // SH-158: a refusal (a wrong PIN, no PIN yet) is felt as well as read.
    val feedback = LocalActionFeedback.current
    val error = state.error
    LaunchedEffect(error) { if (error != null) feedback.reject() }
    com.evoapps.evoshift.widgets.GradientBox(
        Modifier.fillMaxSize().safeDrawingPadding()
    ) {
        Column(Modifier.fillMaxSize()) {
            KioskHeader(
                state,
                onExit = viewModel::openExit,
                onTips = tips?.takeIf { tipsState?.isOpen == false && state.managers.isNotEmpty() }?.let { vm -> { vm.open() } }
            )
            Box(Modifier.weight(1f).fillMaxWidth()) {
                if (tips != null && tipsState?.isOpen == true) {
                    KioskTipsFlow(tipsState, state.managers, tips)
                } else when (val step = state.step) {
                    KioskStep.Grid -> KioskGridWithQr(state, onTile = viewModel::choose, onSomeoneElse = viewModel::openSomeoneElse)
                    is KioskStep.Search -> KioskSearch(state, step, onQuery = viewModel::search, onPerson = viewModel::choose, onBack = viewModel::backToGrid)
                    is KioskStep.Pin -> PinStep(
                        state = state,
                        person = step.person,
                        subtitle = step.tile?.let { tileState(it) },
                        digits = step.digits,
                        actionLabel = actionLabel(step.tile?.action),
                        otherLabel = step.tile?.otherAction?.let { actionLabel(it) },
                        onDigit = viewModel::digit,
                        onBackspace = viewModel::backspace,
                        onSubmit = { viewModel.submit() },
                        onOther = viewModel::submitOther,
                        onBack = viewModel::backToGrid
                    )
                    is KioskStep.Done -> KioskDone(
                        step,
                        onBack = viewModel::backToGrid,
                        photoPath = state.photoPath,
                        photoSending = state.photoSending,
                        onPhoto = viewModel::photoTaken,
                        onSkipPhoto = viewModel::skipPhoto
                    )
                    is KioskStep.Exit -> KioskExit(state, step, viewModel)
                }
            }
            if (state.lockHint == KioskLockHint.GUIDED_ACCESS && state.step == KioskStep.Grid) {
                Text(
                    stringResource(Res.string.kiosk_guided_access_hint),
                    color = Color.White.copy(alpha = 0.6f),
                    style = MaterialTheme.typography.bodySmall,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.fillMaxWidth().padding(12.dp)
                )
            }
        }
        // SH-127: the shift's checklists over the PIN pad or the confirmation.
        val checklist by viewModel.checklist.collectAsState()
        checklist?.let { KioskChecklistOverlay(viewModel, it, state.isSending) }
    }
}

@Composable
private fun KioskHeader(state: KioskUiState, onExit: () -> Unit, onTips: (() -> Unit)? = null) {
    Row(
        Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(Modifier.weight(1f)) {
            Text(state.workplaceName, color = LightGold, style = MaterialTheme.typography.titleMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
            Text(
                stringResource(Res.string.kiosk_who_title),
                color = Color.White,
                fontSize = 32.sp,
                fontWeight = FontWeight.Bold
            )
        }
        if (state.pending > 0) {
            Row(
                Modifier.clip(RoundedCornerShape(16.dp)).background(Color(0xFF8A5A00)).padding(horizontal = 12.dp, vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(Icons.Default.CloudOff, contentDescription = null, tint = Color.White, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(8.dp))
                Text(stringResource(Res.string.kiosk_offline_waiting, state.pending), color = Color.White, style = MaterialTheme.typography.labelLarge)
            }
            Spacer(Modifier.width(12.dp))
        }
        if (state.step == KioskStep.Grid && onTips != null) KioskTipsButton(onTips)
        if (state.step == KioskStep.Grid) {
            val exit = stringResource(Res.string.kiosk_exit)
            IconButton(onClick = onExit, modifier = Modifier.size(56.dp).testTag(KioskTags.EXIT).semantics { contentDescription = exit }) {
                Icon(Icons.Default.Lock, contentDescription = null, tint = Color.White.copy(alpha = 0.5f))
            }
        }
    }
    state.notice?.let { notice ->
        Text(
            notice.asString(),
            color = Color.White,
            modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp).clip(RoundedCornerShape(12.dp))
                .background(Color(0xFF8A1C1C)).padding(12.dp)
        )
    }
}

@Composable
private fun actionLabel(action: ClockAction?): String = when (action) {
    ClockAction.IN -> stringResource(Res.string.kiosk_clock_in)
    ClockAction.OUT -> stringResource(Res.string.kiosk_clock_out)
    ClockAction.BREAK_START -> stringResource(Res.string.kiosk_break_start)
    ClockAction.BREAK_END -> stringResource(Res.string.kiosk_break_end)
    null -> stringResource(Res.string.kiosk_clock_auto)
}

@Composable
private fun tileState(tile: KioskTile): String = when (tile.state) {
    KioskTileState.CAN_CLOCK_IN -> stringResource(Res.string.kiosk_state_ready, tile.plannedStart, tile.plannedEnd)
    KioskTileState.WORKING -> stringResource(Res.string.kiosk_state_working, tile.clockedIn.orEmpty())
    KioskTileState.ON_BREAK -> stringResource(Res.string.kiosk_state_on_break, tile.breakSince.orEmpty())
    KioskTileState.DONE -> stringResource(Res.string.kiosk_state_done)
    KioskTileState.LATER -> stringResource(Res.string.kiosk_state_later, tile.plannedStart)
}

/**
 * SH-111: the grid with the rotating QR beside it in landscape and above it in portrait. Turned
 * off for the workplace, the grid has the whole screen; offline, the panel says "PIN only".
 */
@Composable
private fun KioskGridWithQr(state: KioskUiState, onTile: (KioskTile) -> Unit, onSomeoneElse: () -> Unit) {
    if (state.qr == KioskQrState.Off) {
        KioskGrid(state, onTile, onSomeoneElse)
        return
    }
    BoxWithConstraints(Modifier.fillMaxSize()) {
        val wide = maxWidth > maxHeight && maxWidth >= 640.dp
        if (wide) {
            Row(Modifier.fillMaxSize()) {
                Box(Modifier.weight(1f).fillMaxHeight()) { KioskGrid(state, onTile, onSomeoneElse) }
                KioskQrPanel(state.qr, wide = true, modifier = Modifier.width(300.dp).padding(end = 24.dp, bottom = 16.dp))
            }
        } else {
            Column(Modifier.fillMaxSize()) {
                KioskQrPanel(state.qr, wide = false, modifier = Modifier.fillMaxWidth().padding(start = 16.dp, end = 16.dp, bottom = 12.dp))
                Box(Modifier.weight(1f).fillMaxWidth()) { KioskGrid(state, onTile, onSomeoneElse) }
            }
        }
    }
}

/** The code on white (scanners want dark on light) with its hint, or the offline note. */
@Composable
private fun KioskQrPanel(qr: KioskQrState, wide: Boolean, modifier: Modifier = Modifier) {
    val size = if (wide) 240.dp else 132.dp
    val code: @Composable () -> Unit = {
        Box(
            Modifier.size(size + 24.dp).clip(RoundedCornerShape(16.dp)).background(Color.White).padding(12.dp),
            contentAlignment = Alignment.Center
        ) {
            when (qr) {
                is KioskQrState.Showing -> {
                    val description = stringResource(Res.string.kiosk_qr_description)
                    val painter = rememberQrCodePainter(qr.token, remember { QrOptions(errorCorrectionLevel = QrErrorCorrectionLevel.Medium) })
                    Image(
                        painter = painter,
                        contentDescription = description,
                        modifier = Modifier.size(size).testTag(KioskTags.QR_CODE)
                    )
                }
                KioskQrState.Offline -> Icon(Icons.Default.CloudOff, contentDescription = null, tint = DeepNavy.copy(alpha = 0.5f), modifier = Modifier.size(size / 3))
                else -> CircularProgressIndicator(color = DarkGold)
            }
        }
    }
    val text = stringResource(if (qr == KioskQrState.Offline) Res.string.kiosk_qr_offline else Res.string.kiosk_qr_hint)
    val label: @Composable (Modifier) -> Unit = { m ->
        Text(
            text,
            color = if (qr == KioskQrState.Offline) LightGold else Color.White,
            style = if (wide) MaterialTheme.typography.titleMedium else MaterialTheme.typography.bodyLarge,
            fontWeight = FontWeight.Bold,
            textAlign = if (wide) TextAlign.Center else TextAlign.Start,
            modifier = m
        )
    }
    if (wide) {
        Column(modifier.fillMaxHeight().testTag(KioskTags.QR), horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.Center) {
            code()
            Spacer(Modifier.height(16.dp))
            label(Modifier.fillMaxWidth())
        }
    } else {
        Row(modifier.testTag(KioskTags.QR), verticalAlignment = Alignment.CenterVertically) {
            code()
            Spacer(Modifier.width(16.dp))
            label(Modifier.weight(1f))
        }
    }
}

@Composable
private fun KioskGrid(state: KioskUiState, onTile: (KioskTile) -> Unit, onSomeoneElse: () -> Unit) {
    if (state.isLoading) {
        Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) { CircularProgressIndicator(color = DarkGold) }
        return
    }
    LazyVerticalGrid(
        columns = GridCells.Adaptive(minSize = 180.dp),
        modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp).testTag(KioskTags.GRID),
        horizontalArrangement = Arrangement.spacedBy(16.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        items(state.tiles, key = { it.person.userId }) { tile ->
            Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                PersonTile(tile.person, tileState(tile), highlighted = tile.state == KioskTileState.CAN_CLOCK_IN || tile.state == KioskTileState.WORKING || tile.state == KioskTileState.ON_BREAK) {
                    onTile(tile)
                }
            }
        }
        item(key = "someone-else") {
            KioskCard(onClick = onSomeoneElse) {
                Icon(Icons.Default.PersonSearch, contentDescription = null, tint = LightGold, modifier = Modifier.size(72.dp))
                Spacer(Modifier.height(12.dp))
                Text(stringResource(Res.string.kiosk_someone_else), color = Color.White, fontSize = 20.sp, fontWeight = FontWeight.Bold)
            }
        }
    }
    if (state.tiles.isEmpty()) {
        Text(
            stringResource(Res.string.kiosk_no_one_today),
            color = Color.White.copy(alpha = 0.7f),
            textAlign = TextAlign.Center,
            modifier = Modifier.fillMaxWidth().padding(24.dp)
        )
    }
}

@Composable
internal fun PersonTile(person: KioskPerson, subtitle: String?, highlighted: Boolean = false, onClick: () -> Unit) {
    KioskCard(onClick = onClick, highlighted = highlighted) {
        UserAvatar(name = person.displayName, photoUrl = person.photoUrl, size = 88.dp)
        Spacer(Modifier.height(12.dp))
        Text(
            person.displayName, color = Color.White, fontSize = 20.sp, fontWeight = FontWeight.Bold,
            maxLines = 2, overflow = TextOverflow.Ellipsis, textAlign = TextAlign.Center
        )
        subtitle?.let {
            Spacer(Modifier.height(4.dp))
            Text(it, color = LightGold, style = MaterialTheme.typography.bodyMedium, textAlign = TextAlign.Center)
        }
    }
}

@Composable
private fun KioskCard(onClick: () -> Unit, highlighted: Boolean = false, content: @Composable () -> Unit) {
    // SH-158: a tile sinks a little under the finger, like the clock button.
    val interaction = remember { MutableInteractionSource() }
    Column(
        Modifier
            .pressScale(interaction)
            .fillMaxWidth()
            .heightIn(min = 200.dp)
            .clip(RoundedCornerShape(20.dp))
            .background(if (highlighted) DeepNavy.copy(alpha = 0.95f) else Color.White.copy(alpha = 0.08f))
            .handCursor()
            .clickable(interactionSource = interaction, indication = LocalIndication.current, onClick = onClick)
            .padding(16.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) { content() }
}

@Composable
private fun KioskSearch(
    state: KioskUiState,
    step: KioskStep.Search,
    onQuery: (String) -> Unit,
    onPerson: (KioskPerson) -> Unit,
    onBack: () -> Unit
) {
    Column(Modifier.fillMaxSize().padding(horizontal = 16.dp)) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            BackButton(onBack)
            EvoTextField(
                value = step.query,
                onValueChange = onQuery,
                label = stringResource(Res.string.kiosk_search_hint),
                modifier = Modifier.weight(1f)
            )
        }
        Spacer(Modifier.height(16.dp))
        val others = state.others
        if (others.isEmpty()) {
            Text(stringResource(Res.string.kiosk_no_matches), color = Color.White.copy(alpha = 0.7f), modifier = Modifier.padding(16.dp))
        }
        LazyVerticalGrid(
            columns = GridCells.Adaptive(minSize = 180.dp),
            horizontalArrangement = Arrangement.spacedBy(16.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            items(others, key = { it.userId }) { person -> Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) { PersonTile(person, subtitle = null) { onPerson(person) } } }
        }
    }
}

@Composable
internal fun BackButton(onBack: () -> Unit) {
    IconButtonWithTooltip(onClick = onBack, modifier = Modifier.size(64.dp), tooltip = stringResource(Res.string.back)) {
        Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = stringResource(Res.string.back), tint = Color.White)
    }
}

/** A person, their PIN and the button; in landscape the pad sits beside the person. */
@Composable
private fun PinStep(
    state: KioskUiState,
    person: KioskPerson,
    subtitle: String?,
    digits: String,
    actionLabel: String,
    onDigit: (Char) -> Unit,
    onBackspace: () -> Unit,
    onSubmit: () -> Unit,
    onBack: () -> Unit,
    /** SH-116: the second choice for someone working (start a break) or on a break (clock out). */
    otherLabel: String? = null,
    onOther: () -> Unit = {}
) {
    BoxWithConstraints(Modifier.fillMaxSize().padding(16.dp)) {
        val wide = maxWidth > maxHeight && maxWidth >= 640.dp
        val who: @Composable () -> Unit = {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                UserAvatar(name = person.displayName, photoUrl = person.photoUrl, size = if (wide) 140.dp else 96.dp)
                Spacer(Modifier.height(12.dp))
                Text(person.displayName, color = Color.White, fontSize = 28.sp, fontWeight = FontWeight.Bold, textAlign = TextAlign.Center)
                subtitle?.let { Text(it, color = LightGold, style = MaterialTheme.typography.titleMedium) }
                Spacer(Modifier.height(16.dp))
                Text(stringResource(Res.string.kiosk_enter_pin), color = Color.White.copy(alpha = 0.8f), style = MaterialTheme.typography.titleMedium)
                Spacer(Modifier.height(8.dp))
                PinDots(digits.length)
                state.error?.let {
                    Spacer(Modifier.height(12.dp))
                    Text(it.asString(), color = Color(0xFFFF8A80), textAlign = TextAlign.Center, style = MaterialTheme.typography.titleMedium)
                }
            }
        }
        val pad: @Composable () -> Unit = {
            Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.widthIn(max = 360.dp)) {
                PinPad(onDigit, onBackspace)
                Spacer(Modifier.height(16.dp))
                GoldButton(
                    text = actionLabel,
                    onClick = onSubmit,
                    enabled = digits.length == KioskViewModel.PIN_LENGTH,
                    isBusy = state.isSending,
                    modifier = Modifier.fillMaxWidth().heightIn(min = 72.dp)
                )
                if (otherLabel != null) {
                    Spacer(Modifier.height(12.dp))
                    OutlinedButton(
                        onClick = onOther,
                        enabled = digits.length == KioskViewModel.PIN_LENGTH && !state.isSending,
                        border = BorderStroke(2.dp, LightGold),
                        modifier = Modifier.fillMaxWidth().heightIn(min = 64.dp).testTag(KioskTags.OTHER_ACTION)
                    ) {
                        Text(otherLabel, color = LightGold, fontSize = 20.sp, fontWeight = FontWeight.Bold)
                    }
                }
            }
        }
        Column(Modifier.fillMaxSize()) {
            BackButton(onBack)
            if (wide) {
                Row(Modifier.fillMaxSize(), horizontalArrangement = Arrangement.SpaceEvenly, verticalAlignment = Alignment.CenterVertically) {
                    Box(Modifier.weight(1f), contentAlignment = Alignment.Center) { who() }
                    Box(Modifier.weight(1f), contentAlignment = Alignment.Center) { pad() }
                }
            } else {
                // Short portrait screens (a small phone) scroll rather than cut the pad off.
                Column(
                    Modifier.fillMaxSize().verticalScroll(rememberScrollState()),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(24.dp)
                ) {
                    who()
                    pad()
                }
            }
        }
    }
}

@Composable
internal fun PinDots(count: Int) {
    Row(Modifier.testTag(KioskTags.PIN_DOTS), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
        repeat(KioskViewModel.PIN_LENGTH) { i ->
            Box(
                Modifier.size(18.dp).clip(CircleShape)
                    .background(if (i < count) LightGold else Color.White.copy(alpha = 0.3f))
            )
        }
    }
}

@Composable
internal fun PinPad(onDigit: (Char) -> Unit, onBackspace: () -> Unit) {
    Column(Modifier.testTag(KioskTags.PIN_PAD), verticalArrangement = Arrangement.spacedBy(12.dp)) {
        listOf("123", "456", "789").forEach { row ->
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) { row.forEach { d -> PinKey(d.toString(), Modifier.testTag(KioskTags.key(d))) { onDigit(d) } } }
        }
        Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            Spacer(Modifier.size(KeySize))
            PinKey("0", Modifier.testTag(KioskTags.key('0'))) { onDigit('0') }
            val delete = stringResource(Res.string.kiosk_delete_digit)
            Box(
                Modifier.size(KeySize).clip(CircleShape).handCursor().clickable(onClick = onBackspace).semantics { contentDescription = delete },
                contentAlignment = Alignment.Center
            ) { Icon(Icons.AutoMirrored.Filled.Backspace, contentDescription = null, tint = Color.White) }
        }
    }
}

private val KeySize = 84.dp

@Composable
private fun PinKey(label: String, modifier: Modifier = Modifier, onClick: () -> Unit) {
    Box(
        modifier.size(KeySize).clip(CircleShape).background(Color.White.copy(alpha = 0.12f)).handCursor().clickable(onClick = onClick),
        contentAlignment = Alignment.Center
    ) { Text(label, color = Color.White, fontSize = 32.sp, fontWeight = FontWeight.Medium) }
}

@Composable
private fun KioskDone(
    step: KioskStep.Done,
    onBack: () -> Unit,
    photoPath: String? = null,
    photoSending: Boolean = false,
    onPhoto: (ByteArray?) -> Unit = {},
    onSkipPhoto: () -> Unit = {}
) {
    val result = step.result
    // SH-158: the clock is felt as it lands (in, out, a break; queued offline too).
    val feedback = LocalActionFeedback.current
    LaunchedEffect(result) { feedback.confirm() }
    // SH-134: the optional clock-in photo, taken with the tablet's camera app.
    val picker = com.evoapps.evoshift.photo.rememberImagePicker(onPhoto)
    Column(
        Modifier.fillMaxSize().clickable(enabled = photoPath == null, onClick = onBack).padding(24.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Icon(
            if (result.queued) Icons.Default.CloudOff else Icons.Default.CheckCircle,
            contentDescription = null,
            tint = if (result.queued) LightGold else Color(0xFF66BB6A),
            modifier = Modifier.size(120.dp)
        )
        Spacer(Modifier.height(24.dp))
        val text = when {
            result.queued -> stringResource(Res.string.kiosk_confirm_queued, result.time)
            result.action == ClockAction.OUT -> stringResource(Res.string.kiosk_confirm_out, result.displayName, result.time)
            result.action == ClockAction.BREAK_START -> stringResource(Res.string.kiosk_confirm_break_start, result.displayName, result.time)
            result.action == ClockAction.BREAK_END -> stringResource(Res.string.kiosk_confirm_break_end, result.displayName, result.time)
            else -> stringResource(Res.string.kiosk_confirm_in, result.displayName, result.time)
        }
        Text(text, color = Color.White, fontSize = 30.sp, fontWeight = FontWeight.Bold, textAlign = TextAlign.Center)
        // SH-134: no shift of one's own: covering a colleague, or a new shift; a manager confirms.
        result.unplanned?.let { unplanned ->
            Spacer(Modifier.height(12.dp))
            Text(
                if (unplanned.kind == com.evoapps.evoshift.domain.model.UnplannedKind.COVER) {
                    stringResource(Res.string.kiosk_unplanned_cover, unplanned.coveredName ?: "?")
                } else stringResource(Res.string.kiosk_unplanned_extra),
                color = LightGold, fontSize = 20.sp, textAlign = TextAlign.Center
            )
        }
        KioskTipShareLine(result)
        if (photoPath != null) {
            Spacer(Modifier.height(24.dp))
            Text(stringResource(Res.string.kiosk_photo_title), color = Color.White, fontSize = 22.sp, fontWeight = FontWeight.Bold)
            Text(
                stringResource(Res.string.kiosk_photo_explained),
                color = Color.White.copy(alpha = 0.8f), textAlign = TextAlign.Center, modifier = Modifier.padding(vertical = 8.dp)
            )
            Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                Button(
                    onClick = { picker.takePhoto() },
                    enabled = !photoSending && picker.canTakePhoto,
                    modifier = Modifier.testTag(KIOSK_PHOTO_TAKE_TAG)
                ) { Text(stringResource(Res.string.kiosk_photo_take)) }
                TextButton(onClick = onSkipPhoto, enabled = !photoSending) {
                    Text(stringResource(Res.string.kiosk_photo_skip), color = LightGold)
                }
            }
        } else {
            Spacer(Modifier.height(16.dp))
            Text(stringResource(Res.string.kiosk_back_soon), color = Color.White.copy(alpha = 0.6f))
        }
    }
}

/** SH-134: the tablet's "Take photo" button after a clock-in. */
const val KIOSK_PHOTO_TAKE_TAG = "kiosk_photo_take"

@Composable
private fun KioskExit(state: KioskUiState, step: KioskStep.Exit, viewModel: KioskViewModel) {
    val manager = step.manager
    if (manager == null) {
        Column(Modifier.fillMaxSize().padding(horizontal = 16.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                BackButton(viewModel::backToGrid)
                Column {
                    Text(stringResource(Res.string.kiosk_exit), color = Color.White, fontSize = 24.sp, fontWeight = FontWeight.Bold)
                    Text(stringResource(Res.string.kiosk_exit_text), color = Color.White.copy(alpha = 0.7f))
                }
            }
            Spacer(Modifier.height(16.dp))
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 180.dp),
                horizontalArrangement = Arrangement.spacedBy(16.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                items(state.managers, key = { it.userId }) { person -> PersonTile(person, subtitle = null) { viewModel.pickManager(person) } }
            }
            TextButton(onClick = viewModel::backToGrid) { Text(stringResource(Res.string.close), color = LightGold) }
        }
    } else {
        PinStep(
            state = state,
            person = manager,
            subtitle = stringResource(Res.string.kiosk_exit),
            digits = step.digits,
            actionLabel = stringResource(Res.string.kiosk_exit_confirm),
            onDigit = viewModel::digit,
            onBackspace = viewModel::backspace,
            onSubmit = viewModel::submitExit,
            onBack = viewModel::backToGrid
        )
    }
}

/** The kiosk for a paired tablet's [session] (App.kt shows it instead of the app). */
@Composable
fun KioskHost(session: com.evoapps.evoshift.domain.model.KioskSession) {
    val viewModel: KioskViewModel = com.evoapps.evoshift.di.diViewModel(session)
    val tips: KioskTipsViewModel = com.evoapps.evoshift.di.diViewModel(session)
    KioskScreen(viewModel, tips)
}
